// Import Angular stuff

import { Injectable } from '@angular/core';

/**
 *
 */

@Injectable()
export class SessionStorageService {


  public readonly ADMINISTRATION_PAGINATION: string = 'administration.pagination';

  public readonly DELEGATION_FORM_PAGINATION: string = 'delegationForm.pagination';

  public readonly DELEGATION_PAGINATION: string = 'delegation.pagination';

  public readonly ROUTER_PAGINATION: string = 'router.pagination';

  /**
   *
   * @param {string} key
   * @param {any} value
   */

  put(key: string, value: any) {
    if (value !== undefined && value !== null) {
      if (typeof value === 'object') {
        sessionStorage.setItem(key, JSON.stringify(value));
      } else {
        sessionStorage.setItem(key, value);
      }
    } else {
      sessionStorage.removeItem(key)
    }
  }

  /**
   *
   * @param {string} key
   * @returns {any}
   */

  get(key: string): any {
    const value: string | null = sessionStorage.getItem(key);

    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }

    return null;
  }
}
